<div class="main">
    <div class="heading">Profile Progress</div>
    <div class="container">
        <div class="progressContainer">
            <!-- <circle-progress [percent]="10" [radius]="100" [outerStrokeWidth]="15" [innerStrokeWidth]="3"
                [outerStrokeColor]="'#ED1556'" [innerStrokeColor]="'rgb(233,233,233)'" [animation]="true"
                [animationDuration]="300" responsive="true" unitsFontSize="40" unitsFontWeight="100" titleFontSize="40"
                titleFontWeight="100" showSubtitle="false" backgroundPadding="5" subtitle="">
            </circle-progress> -->
            <!-- <div class="progress">
                <span class="title">85%</span>
                <div class="overlay"></div>
                <div class="left">
                </div>
                <div class="innerLeft"></div>
                <div class="right">
                </div>
                <div class="innerRight"></div>
            </div> -->
        </div>
        <div style="margin-left:7px;">
            <div style="font-weight: 600; font-size:14px">Profile Completed</div>
            <div style="font-size:12px;;">Lorem ipsum dolor sit amet,</div>
        </div>
    </div>

</div>